module.exports = __webpack_public_path__ + "img/test-product.b1838d5f.png";